import { useNavigate } from "react-router-dom";
import { Button, EmptyState } from "../components/ui";

export function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <EmptyState
      icon="∅"
      title="Page not found"
      description="The page you're looking for doesn't exist or has moved."
      action={
        <Button variant="secondary" onClick={() => navigate("/")}>
          Back to queue
        </Button>
      }
    />
  );
}
